import { checkApiFrame } from "./methods/checkApiFrame";
import { getFrameAndIntervalFlag } from "./methods/getFrameAndIntervalFlag";
import { setFrames } from "./methods/setFrames";
import { setMultipleFrame } from "./methods/setMultipleFrame";

export default {
  checkApiFrame,
  getFrameAndIntervalFlag,
  setFrames,
  setMultipleFrame,
};
